import React, {ReactElement} from 'react';
import {t} from 'i18next';
import {DeviceType} from '../../../../incase-domain/common/DeviceType.enum';
import {IQuestionElementProps} from '../../../../incase-domain/elements/base/questionElementBase';
import {IElementSequenceQuestion, SequenceQuestionMode} from '../../../../incase-domain/elements/question/questionSequence';
import Button from '../../../../incase-domain/components/button/Button';
import {getAnswerStyles} from '../common/getStyles';
import QuestionLayout from '../common/QuestionLayout';
import QuestionAnswer, {AnswerTypes} from '../question/QuestionAnswer';

function SequenceQuestionElement(props: IQuestionElementProps<IElementSequenceQuestion>): ReactElement {
    const {element, device = DeviceType.DESKTOP} = props;
    const hostStyled = Boolean(element.htmlSlotId);
    const {sequence} = element;

    const isClickMode = element.sequenceMode === SequenceQuestionMode.CLICK;

    function getAnswers(isClickOption: boolean): JSX.Element[] | undefined {
        return sequence?.map((answer, index) => (
            <QuestionAnswer
                key={`question-answer-${element.id}-${index}`}
                answer={answer.text}
                answerType={AnswerTypes.NONE}
                comment={answer.comment}
                leadingIcon={isClickOption ? undefined : 'akar-icons:drag-vertical'}
                correctColor={element.correctColor}
                incorrectColor={element.incorrectColor}
                debatableColor={element.debatableColor}
                hostStyled={hostStyled}
                styles={getAnswerStyles(device, element)}
                onClick={() => undefined}
            />
        ));
    }

    function getResetButton(): JSX.Element | undefined {
        if (!isClickMode || device !== DeviceType.DESKTOP) return undefined;

        return (
            <Button className="c-sequenceQuestionClickOrder__reset" variant="soft" size="md" dynamicSize disabled>
                <span>{t('common.reset')}</span>
            </Button>
        );
    }

    return (
        <QuestionLayout element={element} device={device} showConfirmButton hostStyled={hostStyled} footerAddon={getResetButton()}>
            <div className="c-sequenceQuestionElement">
                {isClickMode ? (
                    <div
                        className={`c-sequenceQuestionClickOrder ${
                            device === DeviceType.MOBILE ? 'c-sequenceQuestionClickOrder--mobile' : ''
                        }`}
                    >
                        <div className="c-sequenceQuestionClickOrder__column">{getAnswers(true)}</div>
                        <div className="c-sequenceQuestionClickOrder__column">
                            {sequence?.map((_, index) => (
                                <div key={`sequence-slot-${element.id}-${index}`} className="c-sequenceQuestionClickOrder__slot">
                                    <div style={hostStyled ? undefined : getAnswerStyles(device, element)}>{index + 1}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                ) : (
                    <div className="c-sequenceQuestionElement__answers">{getAnswers(false)}</div>
                )}
            </div>
        </QuestionLayout>
    );
}

export default SequenceQuestionElement;
